import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { SubstructureFamily } from "../../../../http/deckDesigner/types/substructureFamilies";
import useDeckSubstructureFamiliesApi from "../../../../http/deckDesigner/useSubstructureFamilies";
import SubstructureFamilyForm from "./SubstructureFamilyForm";

const AdminSubstructureFamilies: FC = () => {
  const i18n = useI18n();
  const substructureFamiliesApi = useDeckSubstructureFamiliesApi();

  return (
    <AdminCrudTable<SubstructureFamily>
      filterPrefix="substructure_families"
      useList={substructureFamiliesApi.useDeckSubstructureFamilies}
      head={<TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>}
      renderRow={(item) => <TableCell>{item.name}</TableCell>}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) =>
          substructureFamiliesApi.updateDeckSubstructureFamilyVisibility(item.code, { visibility }),
        updateOrder: (item, order) => substructureFamiliesApi.updateDeckSubstructureFamilyOrder(item.code, { order }),
      }}
      renderForm={(item, onClose) => <SubstructureFamilyForm substructureFamily={item} onClose={onClose} />}
    />
  );
};

export default AdminSubstructureFamilies;
